/**
 * Calendar items whose assignee is not in the full mechanic roster (a
 * supervisor who started the job, #3080) are shown on the unassigned row.
 *
 * `knownMechanicIds` is every id from useMechanics — not the selected subset.
 * A real mechanic deselected in the filter still hides their work (#2333).
 * Pass null while that roster is loading so assigned jobs do not flash
 * through the unassigned row.
 */
export function reassignNonMechanicItems<T extends { assignedMechanicId: string | null }>(
  items: T[],
  knownMechanicIds: ReadonlySet<string> | null,
): T[] {
  if (knownMechanicIds === null) return items;

  return items.map((item) => {
    const id = item.assignedMechanicId;
    if (id === null || knownMechanicIds.has(id)) return item;
    return { ...item, assignedMechanicId: null };
  });
}
